import { Deserializable } from '../deserializable';
import {DocumentDraftFile} from './documentdraftfile';


export  class DocumentDraft implements Deserializable
{
  public id: number;
  public chuDe: string;
  public noiDung: string;
  public thoiHan: string;
  public thoiGianNhap: string;
  public beLongToID: number;
  public lstReceiveUsers: string;
  public docType: string;
  public replyId: number;
  public documentDraftFiles: DocumentDraftFile[];
  deserialize(input: any): this {
    Object.assign(this, input);
    this.documentDraftFiles = input.documentDraftFiles.map(documentDraftFiles => new DocumentDraftFile().deserialize(documentDraftFiles));
    return this;
  }
}
